<div class="container">
    <div class="row" style="margin-top: 10px; margin-bottom: 20px;">
        <div class="col-sm-6">
            <img id="imgLogo" alt="Insert Logo Here" [src]="companyData?.logoURL" style="max-height: 150px;">
        </div>
        <div class="col-sm-6" style="text-align: right; font-size: 14pt; padding-top: 20px;">
            <span>{{companyData?.companyName}}</span>
            <span>{{clpUserData?.firstName}} {{clpUserData?.lastName}}</span>
        </div>
    </div>
    <div id="pnlMessage">
        <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-12">
                <div class="alert alert-info" [innerHtml]="message ? message : '' | safeHtml"></div>
            </div>
        </div>
    </div>
    <div id="pnlForm" class="innercontainer rounded">
        <form [formGroup]="unsubForm" (ngSubmit)="submitUnsubForm()">
            <div id="pnlEmailEdit" *ngIf="pnlEmailEdit">
                <div class="row">
                    <div class="col-sm-12">
                        <b>Your Email Address</b> (this email will be unsubscribed):<br>
                        <input name="txtEmail" formControlName="txtEmail" type="text" id="txtEmail" class="form-control">
                        <span id="RegularExpressionValidator1" style="color:Red;display:none;">Invalid</span>
                    </div>
                </div>
                <div class="row" style="margin-top:10px;">
                    <div class="col-sm-12">
                        <b>Sender's email address or name</b> (from whom did you receive an email):<br>
                        <input name="txtUserInfo" formControlName="txtUserInfo" type="text" id="txtUserInfo" class="form-control">
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top:10px;">
                <div class="col-sm-12">
                    <table width="100%">
                        <tbody>
                            <tr>
                                <td width="30" style="vertical-align:top;">
                                    <input class="checkbox" formControlName="cbInfo" id="cbInfo" type="checkbox" name="cbInfo">
                                </td>
                                <td [innerHtml]="emailSettings?.prefsInfoDesc ? emailSettings?.prefsInfoDesc : '' | safeHtml"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <table width="100%">
                        <tbody>
                            <tr>
                                <td width="30" style="vertical-align:top;">
                                    <input class="checkbox" id="cbPromo" formControlName="cbPromo" type="checkbox" name="cbPromo">
                                </td>
                                <td [innerHtml]="emailSettings?.prefsPromoDesc ? emailSettings?.prefsPromoDesc : '' | safeHtml"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div id="pnlCommentsBox" class="row">
                <div class="col-sm-12"><br/>
                    <span [innerHtml]="emailSettings?.prefsCommentsTitle ? emailSettings?.prefsCommentsTitle : ''| safeHtml"></span>
                    <br>
                    <textarea formControlName="txtReason" name="txtReason" rows="2" cols="20" id="txtReason" class="form-control"></textarea>
                </div>
            </div>
            <div class="row" style="margin-top:10px;">
                <div class="col-sm-12">
                    <input type="submit" name="btnSave" value="Save Preferences" id="btnSave" class="btn btn-success ml-0">
                </div>
            </div>
        </form>
    </div>
</div>
